<div class="card-header">
  <h1>Wachtwoord<wbr>herstel</h1>
</div>
<div class="card-body">
  <div *ngIf="!activationKey">
    <form (ngSubmit)="recover(form.value)" [formGroup]="form" class="form">
      <h2>voer uw e-mailadres in</h2>
      <div [ngClass]="{ 'input-error': submitted && f.email.errors }">
        <label class="form-label" for="defaultLoginFormEmail">e-mailadres</label>
        <input (ngModelChange)="clearMessage()" formControlName="email" id="defaultLoginFormEmail" type="email">
        <div *ngIf="submitted && f.email.errors" class="error">
          <div *ngIf="f.email.errors.required">{{ 'error.email_required' | translate}}</div>
          <div *ngIf="f.email.errors.pattern">{{ 'error.email' | translate}}</div>
        </div>
      </div>
      <div class="error">
        <div *ngIf="message">{{message}}</div>
      </div>
      <div class="spacer"></div>
      <button type="button" class="btn arrow-left" routerLink="/login">annuleer</button>
      <button class="btn check accent inverted" type="submit">versturen</button>
    </form>
  </div>
</div>
